export class MainItemsViewModel {
     // current navigation object from router
     currentNavigationObject: any;
     // to store value of previous url from router
     previousUrl: string = "";
}